<template>
  <div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col logo">
            <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/logo-tokiomarine.svg"
              alt="Tokio Marine Seguradora">
          </div>
        </div>
      </div>
    </header>
    <section class="banner">
      <span></span>
      <h2>BEM VINDO(A) AO</h2>
      <h1>PORTAL DE INTEGRAÇÕES & API</h1>
      <hr class="divider">
    </section>
    <section class="cadastro">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-10 offset-lg-1">
            <div class="card">
              <h1>FORMULÁRIO DE CADASTRO</h1>
              <hr class="divider">
              <form id="formCadastro" @submit.prevent="onSubmit()">
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fa-regular fa-building"></i>Informações da empresa</legend>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-4 ">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-mask="['###.###.###-##', '##.###.###/####-##']" v-model="cpfCnpj" id="cpfCnpj" ref="cpfCnpj" />
                        <label class="form-label" for="cnpj">CPF/CNPJ:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="nome" id="nome" ref="nome" />
                        <label class="form-label" for="">Nome:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="parceiros.operadora.nomeFantasia"
                          id="nomeFantasia" ref="nomeFantasia" />
                        <label class="form-label" for="">Nome Fantasia:</label>
                        <FormNotch />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="far fa-user"></i>Informações de contato</legend>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-6">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="parceiros.operadora.nomeRespv" id="nomeRespv"
                          ref="nomeRespv" />
                        <label class="form-label" for="">Nome:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-mask="'###.###.###-##'"
                          v-model="parceiros.operadora.cpfRespv" id="cpf" ref="cpf" />
                        <label class="form-label" for="">CPF:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-mask="'(##)#####-####'" v-model="telefones[0].numero"
                          id="telefone" ref="telefone" />
                        <label class="form-label" for="">Telefone:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="parceiros.operadora.emailRespv" id="email"
                          ref="email" />
                        <label class="form-label" for="">E-mail:</label>
                        <FormNotch />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fas fa-map-marker-alt"></i>Informações de endereço da empresa
                  </legend>
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-3">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-mask="'#####-###'" v-model="enderecos[0].cep" id="cep" ref="cep" @blur="buscaCep" />
                        <label class="form-label" for="">CEP:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-7">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="enderecos[0].logradouro" id="logradouro"
                          ref="logradouro" />
                        <label class="form-label" for="">Endereço:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-2">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="enderecos[0].numero" id="numero"
                          ref="numero" />
                        <label class="form-label" for="">Número:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="enderecos[0].complemento" id="complemento" />
                        <label class="form-label" for="">Complemento:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-5">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="enderecos[0].bairro" id="bairro"
                          ref="bairro" />
                        <label class="form-label" for="">Bairro:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4">
                      <div class="form-outline">
                        <input type="text" class="form-control" v-model="enderecos[0].cidade" id="cidade"
                          ref="cidade" />
                        <label class="form-label" for="">Cidade:</label>
                        <FormNotch />
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3">
                      <select class="form-select" v-model="enderecos[0].estado" id="estado" ref="estado">
                        <option value="" selected>Estado</option>
                        <option v-for="e in estados" :value="e.sigla" :key="e.sigla">{{ e.nome }}</option>
                      </select>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fa-solid fa-code"></i>APIs de interesse - Vendas</legend>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <!-- <input class="form-check-input" type="checkbox" id="1" checked="" autocompleted="" data-gtm-form-interact-field-id="0"> -->
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" id="auto" value="Automóvel"
                          ref="apiauto">
                        <span></span>
                        <label class="form-check-label" for="">Automóvel</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Residencial">
                        <span></span>
                        <label class="form-check-label" for="">Residencial</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Imobiliário">
                        <span></span>
                        <label class="form-check-label" for="">Imobiliário</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Condomínio">
                        <span></span>
                        <label class="form-check-label" for="">Condomínio</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Vida">
                        <span></span>
                        <label class="form-check-label" for="">Vida</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Aluguel">
                        <span></span>
                        <label class="form-check-label" for="">Aluguel</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Garantia">
                        <span></span>
                        <label class="form-check-label" for="">Garantia</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Empresarial">
                        <span></span>
                        <label class="form-check-label" for="">Empresarial</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="equipamentos">
                        <span></span>
                        <label class="form-check-label" for="">Equipamentos</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiVendas" value="Viagem">
                        <span></span>
                        <label class="form-check-label" for="">Viagem</label>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fa-solid fa-code"></i>APIs de interesse - Gestão Carteira
                  </legend>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Apólice">
                        <span></span>
                        <label class="form-check-label" for="">Apólice</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Parcelas Pagas">
                        <span></span>
                        <label class="form-check-label" for="">Parcelas Pagas</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Inadimplência">
                        <span></span>
                        <label class="form-check-label" for="">Inadimplência</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Comissão">
                        <span></span>
                        <label class="form-check-label" for="">Comissão</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Renovação">
                        <span></span>
                        <label class="form-check-label" for="">Renovação</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Pendência">
                        <span></span>
                        <label class="form-check-label" for="">Pendência</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Recusa">
                        <span></span>
                        <label class="form-check-label" for="">Recusa</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiGestao" value="Sinistro">
                        <span></span>
                        <label class="form-check-label" for="">Sinistro</label>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fa-solid fa-code"></i>APIs de interesse - Pós Venda</legend>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiPosVenda" value="Apólice">
                        <span></span>
                        <label class="form-check-label" for="">Apólice</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiPosVenda" value="Endosso">
                        <span></span>
                        <label class="form-check-label" for="">Endosso</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiPosVenda" value="Cartão Segurado">
                        <span></span>
                        <label class="form-check-label" for="">Cartão Segurado</label>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 mb-3">
                      <div class="form-check form-switch switch-small">
                        <input class="form-check-input" type="checkbox" autocompleted=""
                          data-gtm-form-interact-field-id="0" v-model="apiPosVenda" value="Boleto">
                        <span></span>
                        <label class="form-check-label" for="">Boleto</label>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="fa-solid fa-dollar-sign"></i>Estimativa aproximada de
                    emissões/mês</legend>
                  <div class="slider-wrapper mt-2">
                    <input type="text" class="js-callback" />
                    <div id="js-display-callback" class="display-box"></div>
                  </div>
                </fieldset>
                <fieldset class="fieldset-border">
                  <legend class="legend-border"><i class="far fa-comment-alt"></i>Informações adicionais</legend>
                  <div class="row">
                    <div class="col">
                      <div class="form-outline">
                        <textarea class="form-control" v-model="parceiros.operadora.infoAdicionais" id="informacoes"
                          ref="informacoes" rows="4" placeholder=""></textarea>
                        <label class="form-label" for="informacoes">Explique-nos um pouco mais sobre o seu
                          negócio:</label>
                        <FormNotch />
                      </div>
                    </div>
                  </div>

                </fieldset>
                <div class="row">
                  <div class="col d-flex justify-content-center">
                    <button type="submit" class="btn btn-primary mt-2 mb-3">CADASTRAR</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col d-flex justify-content-center">
                    <a href="http://portalparceiros.tokiomarine.com.br" target="_blank">Já é cadastrado? Faça login</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer>© Tokio Marine 2024 - Todos os direitos reservados.</footer>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import FormNotch from './FormNotch.vue';

const serviceUrls = {
  localHost: 'http://localhost:8080',
  sistemasAceiteDMZ: 'http://sistemas-aceitedmzw.tokiomarine.com.br',
  sistemasDMZ: 'http://sistemas-dmz.tokiomarine.com.br'
};

const baseUrl = serviceUrls.localHost;

export default {
  components: {
    FormNotch
  },
  directives: { mask },
  data() {
    return {
      cpfCnpj: "",
      tipoPessoa: "",
      nome: "", // razao social
      enderecos: [
        {
          cep: "",
          logradouro: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          complemento: ""
        }
      ],
      emails: [
        {
          email: ""
        }
      ],
      telefones: [
        {
          tipo: "",
          ddd: "",
          numero: ""
        }
      ],
      parceiros: {
        operadora: {
          nomeFantasia: "",
          cpfRespv: "",
          emailRespv: "",
          telefoneRespv: "",
          nomeRespv: "",
          emissaoMes: "",
          infoAdicionais: "",
          apiInteresseVendas: ['Automóvel', 'Residencial', 'Imobiliário', 'Condomínio', 'Vida', 'Aluguel', 'Garantia', 'Empresarial', 'Equipamentos', 'Viagem'],
          apiInteresseGestaoCarteira: ['Apólice', 'Parcelas Pagas', 'Inadimplência', 'Comissão', 'Renovação', 'Pendência', 'Recusa', 'Sinistro'],
          apiInteressePosVenda: ['Apólice', 'Endosso', 'Cartão Segurado', 'Boleto']
        }
      },
      apiVendas: [],
      apiGestao: [],
      apiPosVenda: [],
      estados: [
        { sigla: 'AC', nome: 'Acre' },
        { sigla: 'AL', nome: 'Alagoas' },
        { sigla: 'AP', nome: 'Amapá' },
        { sigla: 'AM', nome: 'Amazonas' },
        { sigla: 'BA', nome: 'Bahia' },
        { sigla: 'CE', nome: 'Ceará' },
        { sigla: 'DF', nome: 'Distrito Federal' },
        { sigla: 'ES', nome: 'Espírito Santo' },
        { sigla: 'GO', nome: 'Goiás' },
        { sigla: 'MA', nome: 'Maranhão' },
        { sigla: 'MT', nome: 'Mato Grosso' },
        { sigla: 'MS', nome: 'Mato Grosso do Sul' },
        { sigla: 'MG', nome: 'Minas Gerais' },
        { sigla: 'PA', nome: 'Pará' },
        { sigla: 'PB', nome: 'Paraíba' },
        { sigla: 'PR', nome: 'Paraná' },
        { sigla: 'PE', nome: 'Pernambuco' },
        { sigla: 'PI', nome: 'Piauí' },
        { sigla: 'RJ', nome: 'Rio de Janeiro' },
        { sigla: 'RN', nome: 'Rio Grande do Norte' },
        { sigla: 'RS', nome: 'Rio Grande do Sul' },
        { sigla: 'RO', nome: 'Rondônia' },
        { sigla: 'RR', nome: 'Roraima' },
        { sigla: 'SC', nome: 'Santa Catarina' },
        { sigla: 'SP', nome: 'São Paulo' },
        { sigla: 'SE', nome: 'Sergipe' },
        { sigla: 'TO', nome: 'Tocantins' }
      ],
      qtd: 0,
      powerangeInstance: null 
    }
  },

  methods: {

    onSubmit() {
      const padraoEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      switch (true) {

        case !this.cpfCnpj || this.cpfCnpj.length < 14:
          this.$refs.cpfCnpj.focus();
          alertUtils.alertError("Preencha o campo CPF/CNPJ!");
          break;

        case !this.nome:
          this.$refs.nome.focus();
          alertUtils.alertError("Preencha o campo Nome!");
          break;

        case this.parceiros.operadora.nomeFantasia == "" && this.cpfCnpj.length > 14:
          this.$refs.nomeFantasia.focus();
          alertUtils.alertError("Preencha o campo Nome Fantasia!");
          break;

        case !this.parceiros.operadora.nomeRespv:
          this.$refs.nomeRespv.focus();
          alertUtils.alertError("Preencha o campo Nome do contato!");
          break;

        case !this.parceiros.operadora.cpfRespv || this.parceiros.operadora.cpfRespv.length < 14:
          this.$refs.cpf.focus();
          alertUtils.alertError("Preencha o campo CPF do contato!");
          break;

        case !this.telefones[0].numero || this.telefones[0].numero.length < 13:
          this.$refs.telefone.focus();
          alertUtils.alertError("Preencha o campo Telefone!");
          break;

        case !this.parceiros.operadora.emailRespv:
          this.$refs.email.focus();
          alertUtils.alertError("Preencha o campo E-mail!");
          break;

        case !padraoEmail.test(this.parceiros.operadora.emailRespv):
          this.$refs.email.focus();
          alertUtils.alertError("Por favor, insira um e-mail válido");
          break;

        case !this.enderecos[0].cep:
          this.$refs.cep.focus();
          alertUtils.alertError("Preencha o campo Cep!");
          break;

        case !this.enderecos[0].logradouro:
          this.$refs.logradouro.focus();
          alertUtils.alertError("Preencha o campo Endereço!");
          break;

        case !this.enderecos[0].numero:
          this.$refs.numero.focus();
          alertUtils.alertError("Preencha o campo número!");
          break;

        case !this.enderecos[0].bairro:
          this.$refs.bairro.focus();
          alertUtils.alertError("Preencha o campo bairro!");
          break;

        case !this.enderecos[0].cidade:
          this.$refs.cidade.focus();
          alertUtils.alertError("Preencha o campo cidade");
          break;

        case !this.enderecos[0].estado:
          this.$refs.estado.focus();
          alertUtils.alertError("Preencha o campo estado!");
          break;

        case this.listaAPIVenda.length === 0:
          this.$refs.apiauto.focus();
          alertUtils.alertError("Selecione ao menos uma API de interesse!");
          break;

        case this.quantidadeEmissoes() === "0 - Emissões":
          alertUtils.alertError("Selecione uma estimativa aproximada de emissões/mês!");
          break;

        case !this.parceiros.operadora.infoAdicionais:
          this.$refs.informacoes.focus();
          alertUtils.alertError("Preencha o campo informações adicionais!");
          break;

        default:
          if(this.cpfCnpj.length <= 14){
            this.tipoPessoa = "F"
          }else{
            this.tipoPessoa = "J"
          }
          this.enviarRequisicao();
      }

    },

    enviarRequisicao() {
      const dadosParaEnviar = {
        cpfCnpj: this.cpfCnpj.replaceAll('.', '').replaceAll('-', '').replaceAll('/', ''),
        tipoPessoa: this.tipoPessoa,
        nome: this.nome,
        enderecos: this.enderecos.map(endereco => ({
          ...endereco,
          cep: endereco.cep.replaceAll('-', '')
        })),
        // emails: this.emails.map(email => ({ ...email })),
        emails: this.emails.map(() => ({ email: this.parceiros.operadora.emailRespv })),
        telefones: this.telefones.map(telefone => ({
          tipo: 'C',
          ddd: this.extractDDD(telefone.numero),
          numero: telefone.numero.slice(4).replaceAll('-', '')
        })),
        parceiros: {
          operadora: {
            ...this.parceiros.operadora,
            cpfRespv: this.parceiros.operadora.cpfRespv.replaceAll('.', '').replaceAll('-', ''),
            telefoneRespv: this.telefones.length > 0 ? this.telefones[0].numero.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '') : '',
            emissaoMes: parseInt(this.qtd.replace(' - Emissões', '').replace('.', '')),
            apiInteresseVendas: this.parceiros.operadora.apiInteresseVendas.map(item => ({
              descricao: item,
              status: this.apiVendas.includes(item) // Define o status como true se o item estiver selecionado
            })),
            apiInteresseGestaoCarteira: this.parceiros.operadora.apiInteresseGestaoCarteira.map(item => ({
              descricao: item,
              status: this.apiGestao.includes(item)
            })),
            apiInteressePosVenda: this.parceiros.operadora.apiInteressePosVenda.map(item => ({
              descricao: item,
              status: this.apiPosVenda.includes(item)
            })),
          }
        }
      };

      // console.log('Corpo da requisição:', dadosParaEnviar);

      //Com API Gateway
         loaderUtils.addLoarder();
         this.obterToken()
            .then(token => {
               //MUDANÇA URL
               //return fetch('http://localhost:8080/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/salvar', {
               return fetch('https://servicos.tokiomarine.com.br/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/salvar', {
               //return fetch('https://apis-aceite.tokiomarine.com.br/gateway/gerenciador-parceiros-w/rest/pre-cadastro-operadora-api/salvar', {
               //return fetch('https://apis.tokiomarine.com.br/gateway/gerenciador-parceiros/rest/pre-cadastro-operadora-api/salvar', {
                method: 'POST', 
                headers: {
                  'Content-Type': 'application/json', 
                  'Authorization': `Bearer ${token}` 
                },
                body: JSON.stringify(dadosParaEnviar)
              });
            })
            .then(response => {
              if (!response.ok) {
               alertUtils.alertError('Erro ao cadastrar!');
              }
              loaderUtils.removeLoader();
              return response.text(); 
            })
            .then(data => {
             loaderUtils.removeLoader();
             if (data != "OK") {
                alertUtils.alertError(data);
             } else {
                alertUtils.alertSuccess("Cadastro enviado com sucesso! Em breve você receberá um e-mail com demais instruções de acesso!") 
                this.resetForm();
             }
            })
            .catch(error => {
             loaderUtils.removeLoader();
              if (error.message.includes('Failed')) {
                    alertUtils.alertError('Erro na obtenção do token: ' + error.message);
                } else {
                  alertUtils.alertError('Erro ao cadastrar: ' + error.message);
                }
            })
      //Sem API Gateway
      //  loaderUtils.addLoarder();
      //  fetch(`${baseUrl}/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/salvar`, {
      //    method: 'POST', // Método da requisição
      //    headers: {
      //      'Content-Type': 'application/json'// Tipo de conteúdo da requisição
      //    },
      //    body: JSON.stringify(dadosParaEnviar) // Corpo da requisição, convertido para JSON
      //  })
      //    .then(response => {
      //      if (!response.ok) {
      //        throw new Error('Erro ao enviar requisição'); // Lançar um erro caso a resposta não esteja ok
      //      }
      //      return response.text();
      //    })
      //    .then(data => {
      //      console.log('Resposta da requisição:', data);
      //      loaderUtils.removeLoader();
      //      alertUtils.alertSuccess("Cadastro enviado com sucesso!")
      //      this.resetForm();
      //    })
      //    .catch(error => {
      //      console.error('Erro:', error.message); // Log do erro, caso ocorra
      //      loaderUtils.removeLoader();
      //    });
    },

    async buscaCep() {

      if (this.enderecos[0].cep.length < 9 || this.enderecos.cep == "") {

        this.enderecos[0].logradouro = "";
        this.enderecos[0].bairro = "";
        this.enderecos[0].numero = "";
        this.enderecos[0].cidade = "";
        this.enderecos[0].estado = "";
        return
      }

       try {
        const token = await this.obterToken();

        if (!token) {
          alertUtils.alertError('Erro na obtenção do token!');
        }

        const requestOptions = {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }

        const cep = this.enderecos[0].cep.replace('-', '');
        loaderUtils.addLoarder();
        
        //MUDANÇA URL
        //const response = await fetch(`http://localhost:8080/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/consultar-cep/${cep}`);
        const response = await fetch(`https://servicos.tokiomarine.com.br/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/consultar-cep/${cep}`);
        //const response = await fetch(`https://apis-aceite.tokiomarine.com.br/gateway/gerenciador-parceiros-w/rest/pre-cadastro-operadora-api/consultar-cep/${cep}`, requestOptions);
        //const response = await fetch(`https://apis.tokiomarine.com.br/gateway/gerenciador-parceiros/rest/pre-cadastro-operadora-api/consultar-cep/${cep}`, requestOptions);
        //const response = await fetch(`${baseUrl}/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/consultar-cep/${cep}`);
        
        if (!response.ok) {
          alertUtils.alertError('Erro ao buscar o endereço: ' + error.message);
        }

        const data = await response.json();

        this.enderecos[0].logradouro = data[0].logradouro2;
        this.enderecos[0].bairro = data[0].bairro;
        this.enderecos[0].cidade = data[0].cidade;
        this.enderecos[0].estado = data[0].uf;

        // this.$nextTick() Garantir a execução após a proxima atualização do DOM
        this.$nextTick(() => {
          document.getElementById('logradouro').focus();
          document.getElementById('bairro').focus();
          document.getElementById('cidade').focus();
          document.getElementById('estado').focus();
          document.getElementById('numero').focus();
        });

      } catch (error) {
         if (error.message.includes('Failed')) {
            alertUtils.alertError('Erro na obtenção do token: ' + error.message);
         } else {
           alertUtils.alertError('Erro ao buscar o endereço: ' + error.message);
         }
      } finally {
        loaderUtils.removeLoader();
      }
    },

    async obterToken() {
      return "token";
    },
    /*
    async obterToken() {
      //const urlAutenticacao = 'https://apis-aceite.tokiomarine.com.br/invoke/pub.apigateway.oauth2/getAccessToken';
      const urlAutenticacao = 'https://apis.tokiomarine.com.br/invoke/pub.apigateway.oauth2/getAccessToken';

      const requestOptions = {
        // act
         //client_id: '5607c6aa-01d1-461f-8d8b-2b4450aef51a',
         //client_secret: '78cb00f7-ad04-4b46-b269-8c7d0b657cb0',
        // prd
        client_id: '950cef86-22e2-43cd-8456-2fe31378e61d',
        client_secret: '6d7e6330-adc4-4e6a-b7d3-5a43bc97a877',
        grant_type: 'client_credentials'
      };

      const params = new URLSearchParams(requestOptions);
      const urlComParametros = `${urlAutenticacao}?${params.toString()}`;

      try {
        const response = await fetch(urlComParametros, { method: 'GET' });

        if (!response.ok) {
          alertUtils.alertError('Erro na obtenção do token');
          return null;
        }

        const data = await response.json();
        return data.access_token;

      } catch (error) {
        return null;
      }
    },
    */

    quantidadeEmissoes() {
      this.qtd = document.querySelector("#js-display-callback").textContent.trim();
      return this.qtd
    },

    displayRanger() {
      var range = document.querySelector('.js-callback');
      var valor = range.value;
      var txt = " - Emissões"

      if (valor > 1000) {
        var valorFormatado = this.formatarNumeroComPontoRanger(valor);
        document.getElementById('js-display-callback').innerHTML = valorFormatado + txt;
      } else {
        document.getElementById('js-display-callback').innerHTML = valor + txt;
      }
    },

    formatarNumeroComPontoRanger(numero) {
      var partes = numero.toString().split(".");
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return partes.join(".");
    },

    initializePowerange() {
      var range = document.querySelector('.js-callback');

      if (this.powerangeInstance) {
        this.powerangeInstance = null; // Remove a referência à instância anterior
      }

      this.powerangeInstance = new Powerange(range, {
        callback: this.displayRanger,
        start: 0,
        min: 0,
        max: 10000
      });

      document.querySelector(".range-max").textContent = "10.000";
    },
    resetSlider() {
      var range = document.querySelector('.js-callback');
      range.value = 0; // Define o valor do slider para 0
      this.displayRanger(); // Atualiza a exibição

      // Atualiza manualmente a barra visual
      var rangeHandle = document.querySelector('.range-handle');
      var rangeQuantity = document.querySelector('.range-quantity');
      if (rangeHandle && rangeQuantity) {
        rangeHandle.style.left = '0px';
        rangeQuantity.style.width = '0px';
      }
    },
    extractDDD(telefone) {
      // Remove parênteses, traços e espaços em branco do número de telefone
      const numeroLimpo = telefone.replace(/[\(\)\-\s]/g, '');
      // Extrai os três primeiros dígitos do número, que correspondem ao DDD
      return numeroLimpo.substring(0, 2);
    },

    resetForm() {
      //window.location.reload();
      this.cpfCnpj = "";
      this.tipoPessoa = "";
      this.nome = "";
      this.parceiros.operadora.nomeFantasia = "";
      this.parceiros.operadora.nomeRespv = "";
      this.parceiros.operadora.cpfRespv = "";
      this.telefones[0].numero = "";
      this.parceiros.operadora.emailRespv = "";
      this.enderecos[0].cep = "";
      this.enderecos[0].logradouro = "";
      this.enderecos[0].numero = "";
      this.enderecos[0].complemento = "";
      this.enderecos[0].bairro = "";
      this.enderecos[0].cidade = "";
      this.enderecos[0].estado = "";
      // apis vendas
      for (let key in this.apiVendas) {
        if (this.apiVendas.hasOwnProperty(key)) {
          this.apiVendas[key] = false;
        }
      }
      // apis gestao
      for (let key in this.apiGestao) {
        if (this.apiGestao.hasOwnProperty(key)) {
          this.apiGestao[key] = false;
        }
      }
      // apis pós venda
      for (let key in this.apiPosVenda) {
        if (this.apiPosVenda.hasOwnProperty(key)) {
          this.apiPosVenda[key] = false;
        }
      }
      // Power Range
      this.resetSlider();
      // Infos adicionais
      this.parceiros.operadora.infoAdicionais = "";
    }
  },

  computed: {
    listaAPIVenda() {
      // Filtrar a lista original para incluir apenas os itens selecionados
      return this.parceiros.operadora.apiInteresseVendas.filter(item => this.apiVendas.includes(item));
    },

  },
  watch: {

  },

  created() {
    // Importando o powerrange
    const script = document.createElement('script');
    script.src = '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/js/powerange.min.js';
    script.async = true;

    // Adicionando um ouvinte para o evento 'load' do script
    script.addEventListener('load', () => {
      this.initializePowerange(); // inicializando o Powerange após o carregamento
    });

    document.head.appendChild(script);
  },

  mounted() {
    document.querySelector("body").classList.add("cadastro");
    // document.title = 'API de integração | Portal de Integrações & API Tokio Marine';

  }

};
</script>

<style>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/powerange.css';
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/style.css';


header {
  position: relative;
}

.banner {
  margin-top: 0;
}


.form-outline .form-control {
  border: 1px solid #bdbdbd;
}

.form-outline .form-control:focus {
  border-color: #0B9274;
  box-shadow: 0px 0 0 0 #0B9274, 0 0 0 0 #0B9274, 0 0px 0 0 #0B9274
}

@media (min-width: 768px) {

  .container,
  .container-md,
  .container-sm {
    max-width: 95%;
  }
}

@media (min-width: 576px) {

  .container,
  .container-sm {
    max-width: 95%;
  }

}

@media (max-width: 576px) {

  section.cards .card,
  section.cadastro .card {
    margin: 2rem auto 0;
  }

  /* .form-check-label {
    margin-left: -.7rem;
    font-size: .8rem;
  } */

  .slider-wrapper {
    width: 90%;
  }
}

/* @media (max-width: 500px) {

  fieldset.fieldset-border {
    border: none;
    padding: .5rem 0 0 0;
  }
  .form-check-label {
    margin-left: -.9rem;
    font-size: .75rem;
  }

} */
</style>
